export default __webpack_public_path__ + "static/media/nft-0@2x.55c8fd9c.png";